
export interface TransformedSubject {
  grade_level: string;
  subjects: Array<{
    subject: string;
    course_types: string[];
  }>;
}

export const transformSubjects = (subjects: any[]): TransformedSubject[] => {
  if (!Array.isArray(subjects)) return [];

  // Group by grade_level
  const gradeMap = new Map<string, Map<string, Set<string>>>();

  subjects.forEach(item => {
    if (item && typeof item === 'object' && item.subject && item.grade_level) {
      const gradeLevel = item.grade_level;
      const subject = item.subject;
      const courseType = item.course_type || '';

      if (!gradeMap.has(gradeLevel)) {
        gradeMap.set(gradeLevel, new Map());
      }
      const subjectMap = gradeMap.get(gradeLevel)!;
      if (!subjectMap.has(subject)) {
        subjectMap.set(subject, new Set());
      }
      subjectMap.get(subject)!.add(courseType);
    }
  });

  // Create array according to the new structure
  const result: TransformedSubject[] = [];

  gradeMap.forEach((subjectMap, gradeLevel) => {
    const subjectsArr: Array<{ subject: string; course_types: string[] }> = [];
    subjectMap.forEach((courseTypeSet, subject) => {
      subjectsArr.push({
        subject,
        course_types: Array.from(courseTypeSet).filter(Boolean)
      });
    });
    result.push({
      grade_level: gradeLevel,
      subjects: subjectsArr.sort((a, b) => a.subject.localeCompare(b.subject))
    });
  });

  return result.sort((a, b) => a.grade_level.localeCompare(b.grade_level));
};
